import { defineStore } from 'pinia';

export const usesearchResultsStore = defineStore('SearchResults', {
  state: () => ({
    results: []
  })
});